<template>
<v-row class="align-center">
  <v-col cols="12" md="12" class="pa-0" v-for="(r, i) in resource.data" :key="'resource-'+i"  >
    <v-row>
      <v-col cols="12">
        <v-card :loading="loading">
          <v-card-text class="py-0">
            <v-row class="py-0">
              <v-col cols="8" :class="`${arabic?'arFont':'enFont'}`">
                <div style="font-size:10px;font-weight:bold;">المحاضرة</div>
                <div :class="`${arabic_input(r.title) ? 'arFont' : 'enFont text-left'}`" :style="`${!arabic_input(r.title) ? 'direction:ltr !important;font-weight:bold;' : ''}`">{{r.title}}</div>
                <div :class="`${arabic_input(r.text) ? 'arFont' : 'enFont text-left'}`" :style="`${!arabic_input(r.text) ? 'direction:ltr !important' : ''}`">{{r.text}}</div>
              </v-col>
              <v-col cols="4" :class="`${arabic?'arFont':'enFont'}`">
                <div style="font-size:10px;font-weight:bold;">معلومات عن المحاضرة</div>
                <div>
                  <v-chip x-small label color="secondary">{{getFormat(r.created_at)}}</v-chip>
                </div>
                <div class="text-left">
                  <v-btn color="primary" x-small :class="`${arabic?'arFont':'enFont'}`" @click="goTo(`/admin-session/${r.hash}`)">
                    عرض المحاضرة 
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-col>
</v-row>
</template>

<script>
import { format } from 'timeago.js';
export default {
  props:['resourceSettings', 'resource' , 'resourceKeys', 'loading'],
  methods:{
    goTo(path) {
      this.$router.push(path).catch(x=>{})
    },
    getFormat(d){
      return format(d)
    },
    clipboardSuccessHandler ({ value, event }){
      this.$emit('copyS', { value, event })
    },
    clipboardErrorHandler ({ value, event }) {
      this.$emit('copyF', { value, event })
    },
    arabic_input(string){
      var arabic = /[\u0600-\u06FF]/;
      return arabic.test(string)
    },
  },
  computed:{
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    user(){
      return this.$store.state.user
    },

  }
}
</script>

<style>

</style>